// CacheKey ccd9e7ba0f94490cd7f008692eeaeb8f
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  ar: {
    date: {
      day_names: [
        "الأحد",
        "الإثنين",
        "الثلاثاء",
        "الأربعاء",
        "الخميس",
        "يوم الجمعة",
        "يوم السبت"
      ],
      formats: {
        default: "%d/%m/%Y",
        long: "%d %B %Y"
      },
      month_names: [
        null,
        "كانون الثاني",
        "شهر فبراير",
        "مارس",
        "أبريل",
        "مايو",
        "يونيو",
        "يوليو",
        "أغسطس",
        "سبتمبر",
        "اكتوبر",
        "شهر نوفمبر",
        "ديسمبر"
      ],
      order: [
        "يوم",
        "شهر",
        "عام"
      ]
    },
    time: {
      am: "صباحا",
      formats: {
        default: "%A, %d من %B من %Y %H:%M:%S %z",
        long: "%d من %B من %Y %H:%M",
        short: "%d من %b %H:%M"
      },
      pm: "مساءً"
    },
    time_zones: {
      est: "التوقيت الشرقي",
      edt: "التوقيت الشرقي",
      cst: "التوقيت المركزي",
      cdt: "التوقيت المركزي",
      mst: "التوقيت الجبلي",
      mdt: "التوقيت الجبلي",
      pst: "توقيت المحيط الهادئ",
      pdt: "توقيت المحيط الهادئ",
      hst: "توقيت هاواي-ألوتيان",
      hdt: "توقيت هاواي-ألوتيان",
      akst: "توقيت ألاسكا",
      akdt: "توقيت ألاسكا"
    }
  }
}

